import React from 'react';
import LoginSlider from '../shared/LoginSlider';
import ProdytSignIn from './ProdytSignIn';
import { useIsMobile } from '../../../hooks/use-mobile';

export const ProdytAuthContainer = () => {
  const isMobile = useIsMobile();

  return (
    <div style={{ display: 'flex', flexDirection: isMobile ? 'column' : 'row', width: '100%', minHeight: '100vh', background: 'white' }}>
      {/* Left Side - Slider */}
      {!isMobile && (
      <div style={{ 
        flex: 1, 
        minWidth: 0,
        display: 'flex', 
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        padding: isMobile ? '24px 16px' : '40px 20px 40px 40px',
        background: 'linear-gradient(135deg, #052f26 0%, #0a4d3c 100%)',
        color: 'white',
        paddingTop: isMobile ? '24px' : '40px',
        maxHeight: isMobile ? 'none' : '100vh',
        overflowY: 'auto',
        overflowX: 'hidden'
      }}>
        <div style={{ flex: 1, maxWidth: '100%', width: '100%', display: 'flex', flexDirection: 'column' }}>
          {/* Logo Section - Horizontal */}
          <div style={{ marginBottom: isMobile ? '24px' : '60px', display: 'flex', alignItems: 'center', gap: '12px' }}>
            <div style={{
              width: isMobile ? '40px' : '48px',
              height: isMobile ? '40px' : '48px',
              borderRadius: '10px',
              background: '#1a4a9e',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: isMobile ? '20px' : '24px',
              fontWeight: 'bold',
              color: 'white'
            }}>
              P
            </div>
            <h1 style={{ fontSize: isMobile ? '24px' : '28px', fontWeight: 'bold', margin: '0', color: 'white' }}>
              Prodyt
            </h1>
          </div>
          {/* Slider Section - Centered */}
          <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%' }}>
            <LoginSlider />
          </div>
        </div>
      </div>
      )}

      {/* Right Side - Auth Form */}
      <div style={{ 
        flex: 1, 
        minWidth: 0,
        display: 'flex', 
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        padding: isMobile ? '20px 16px 24px' : '40px',
        background: 'white',
        overflowY: 'auto',
        overflowX: 'hidden'
      }}>
        <div style={{ width: '100%', maxWidth: isMobile ? '100%' : '400px' }}>
          <ProdytSignIn />
        </div>
      </div>
    </div>
  );
};

export default ProdytAuthContainer;
